import React from "react";
import "./PartnersComp.css";
import ngoPartnerImg from "../../Images/ngoPartnerImg.jpg";
import ngoPartnerImg1 from "../../Images/ngoPartnerImg1.png";
import ngoPartnerImg2 from "../../Images/ngoPartnerImg2.jpg";
import ngoPartnerImg3 from "../../Images/ngoPartnerImg3.png";
import partnerImg3 from "../../Images/partnerImg3.png";

const NgoPartner = () => {
  return (
    <div className="collegePartner">
      <div className="partnerCompContainer">
        <div className="partnerComp">
          <img
            src={ngoPartnerImg}
            alt="ngoPartnerImg"
            className="partnerCompImg"
          />
          <div className="partnerCompCover">
            <h2>NGO Alliances for Inclusive Career Empowerment</h2>
            <p>
              Career Restorer works with mission-driven NGOs to empower
              underserved communities through inclusive career guidance, skill
              development, and access to meaningful opportunities.
            </p>
            <a href="/joinPartnerForm">
              <button>Join as Partner</button>
            </a>
          </div>
        </div>
        <div className="partnerCompSection2">
          <div className="partnerCompSection2Text">
            <h3>What is CSR & NGO?</h3>
            <p>
              <b>Corporate Social Responsibility (CSR)</b> means companies
              taking action to give back to society—like supporting education,
              environment, or health.
            </p>
            <p>
              <b>Non-Governmental Organizations (NGOs)</b> are independent,
              nonprofit groups that work on social and humanitarian issues.
            </p>
            <p>
              CSR and NGOs both help create opportunities for learning,
              internships, and career growth while building a better society.
            </p>
          </div>
          <img src={ngoPartnerImg1} alt="serviceApplicationImg1" />
        </div>
        <div className="partnerCompSection2">
          <img src={ngoPartnerImg2} alt="serviceApplicationImg1" />
          <div className="partnerCompSection2Text">
            <h3>CSR Activities & Impact</h3>
            <p>
              <i class="fa-solid fa-check"></i>
              Educational programs and scholarships for underprivileged
              students.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>Skill development workshops and
              vocational training.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>Environmental conservation and
              awareness campaigns.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>Health and wellness camps for
              communities.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>Support for research & innovation
              initiatives.
            </p>
            <p>
              <i class="fa-solid fa-check"></i>
              These efforts create real career-building opportunities through
              internships and training programs.
            </p>
          </div>
        </div>
        <div className="partnerCompCollaboration">
          <div className="partnerCompCollaborationText">
            <h3>How We Support CSR & NGOs</h3>
            <p>
              We help promote CSR initiatives and NGO activities on our
              platform. You'll find updates on training, internships, and events
              that align with social goals.
            </p>
            <p>
              Stay tuned for upcoming drives and volunteer programs you can
              join.
            </p>
          </div>
          <div className="partnerCompCollaborationImg">
            <img src={ngoPartnerImg3} alt="partnerImg3" />
          </div>
        </div>

        <div className="partnerCompCollaboration">
          <div className="partnerCompCollaborationImg">
            <img src={partnerImg3} alt="partnerImg3" />
          </div>
          <div className="partnerCompCollaborationText">
            <h3>NGO Collaborations & Opportunities</h3>
            <p>
              We partner with NGOs working in education, women empowerment,
              training, and welfare. Many offer volunteer and internship roles.
            </p>
            <p>
              Join to gain experience, grow your network, and contribute to
              social change.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NgoPartner;
